import React from "react";
// import Common Banner
import CommonBanner from "../component/Common/CommonBanner";
// import TourDetails
import HajjPackageDetails from "../component/HajjPackageDetails";
import { ImageConstants } from "../assets/img/ImageConstants";
import { Helmet } from "react-helmet-async";
import UmrahPackageDetails from "../component/UmrahPackageDetails";

const TourDetails = () => {
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Umrah Packages 2025 | Premium & Economy Packages | Polani Travels
        </title>
        <meta
          name="description"
          content="Book your Hajj 2025 packages with Polani Travels. All-inclusive packages with 5-star hotels, VIP transport, dedicated guides, and Ziyarat services. Licensed by Ministry of Religious Affairs Pakistan."
        />
        <meta
          name="keywords"
          content="Umrah Packages 2025, hajj booking, hajj from pakistan, economy hajj package, VIP hajj package, hajj guide, makkah hotel booking, madina hotel booking, hajj visa service, polani travels hajj"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://polani-2c215.web.app/hajj-packages"
        />
        <meta
          property="og:title"
          content="Umrah Packages 2025 | Premium & Economy Options | Polani Travels"
        />
        <meta
          property="og:description"
          content="Discover our comprehensive Hajj 2025 packages including 5-star accommodations, VIP transport, experienced guides, and complete Ziyarat services. Ministry approved Hajj operator serving pilgrims since 1990."
        />
        <meta
          property="og:image"
          content="https://polani-2c215.web.app/static/media/hajj-p1.b3b5049431c01609ac97.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="polani-2c215.web.app" />
        <meta
          property="twitter:url"
          content="https://polani-2c215.web.app/hajj-packages"
        />
        <meta
          name="twitter:title"
          content="Umrah Packages 2025 | Licensed Hajj Operator | Polani Travels"
        />
        <meta
          name="twitter:description"
          content="Book your Hajj 2025 journey with Pakistan's trusted Hajj operator. Featuring luxury hotels near Haram, dedicated transport, experienced guides, and complete pilgrimage support."
        />
        <meta
          name="twitter:image"
          content="https://polani-2c215.web.app/static/media/hajj-p1.b3b5049431c01609ac97.jpg"
        />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://polani-2c215.web.app/hajj-packages"
        />
        <meta name="author" content="Polani Travels" />
      </Helmet>
      <CommonBanner
        heading="Umrah Packages Available"
        img={ImageConstants.umrahbanner}
        pagination="Packages Details"
      />
      <UmrahPackageDetails />
    </>
  );
};

export default TourDetails;
